import { useMutation } from 'react-query';
import request from '../../../../../helpers/request';

const changeDefaultFilter = async (id) => {
  const data = { id, value: true };

  await request.put(
    '/Filter/default',
    data,
    'Произошла ошибка при установке фильтра',
    'Error',
    null,
    { type: 'ALERT' }
  );
};

const useChangeDefaultFilter = () => {
  const mutation = useMutation(changeDefaultFilter, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isChangeDefaultFilterLoading: mutation.isLoading,
    onChangeDefaultFilter: mutation.mutateAsync,
  };
};

export default useChangeDefaultFilter;
